<template>
  <ActionButton
    v-if="isPaymentAvailable"
    :label="`יצירת\nחיוב`"
    desktopLabel="יצירת חיוב"
    icon="pi-credit-card"
    @action="openPaymentModal('payment')"
  />
  <ActionButton
    v-if="isInvoiceAvailable"
    :label="`יצירת\nחשבונית`"
    desktopLabel="יצירת חשבונית"
    icon="pi-receipt"
    @action="openPaymentModal('invoice')"
  />
</template>

<script setup lang="ts">
import { ClientFeatures } from '@torim-app/types';
import { computed } from 'vue';
import { checkFeatureIsAvailable } from '@torim-app/utils';
import { useAdminStore } from '@app/stores';
import SendPaymentRequest from '@app/components/admin/pages/home/SendPaymentRequest.vue';
import { useDrawer } from '@torim-app/shared-components';
import ActionButton from '@app/components/admin/components/ActionButton.vue';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const { openDrawer } = useDrawer();

const isPaymentAvailable = computed(() => {
  return adminStore.businessSiteData?.hasPayments &&
    adminStore.getMainClient;
});

const isInvoiceAvailable = computed(() => {
  return adminStore.businessSiteData?.hasInvoices &&
    adminStore.getMainClient;
});

const openPaymentModal = (type: 'invoice' | 'payment') => {
  trackEvent('payment_action_clicked', { type });
  openDrawer(SendPaymentRequest, {
    selectedAction: type
  }, {
    closable: true,
    title: type === 'payment' ? 'יצירת חיוב' : 'הפקת חשבונית',
    noPadding: true
  });
};

</script>
